import * as React from "react";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { YesNoUnknownDropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoUnknownDropdownQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { Message, List } from "semantic-ui-react";

interface Props {
    questions: AnsweredQuestionWithId[];
    readonly: boolean;
    index?: number;
    questionnaireKey: string;
}

export const BbvSourcePatientRiskAssessmentSection: React.FunctionComponent<Props> = (props: Props) => {
    return  (
        <AccordionQuestionnaireSection
            id="SourcePatientRiskAssessment"
            title="Source Patient Risk Assessment"
            index={props.index}
        >
            {(getAnswerToQuestionWithId(props.questions, "SourceFromHighPrevalence")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={({
                    id: "SourceFromHighPrevalence",
                    questionText: "Is the source patient from an area of high prevalence, particularly Sub-Saharan Africa?"
                })}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientKnownToHaveSexWithMen")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={({
                    id: "SourcePatientKnownToHaveSexWithMen",
                    questionText: "Is the source patient a man known to have sex with men?"
                })}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientIvDruguser")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={({
                    id: "SourcePatientIvDruguser",
                    questionText: "Is the source patient an IV drug user?"
                })}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientMotherInfectedWithHiv")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientMotherInfectedWithHiv",
                    questionText: "Does the source patient have a mother known to be infected with HIV?"
                }}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientMotherInfectedWithHepatitisB")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientMotherInfectedWithHepatitisB",
                    questionText: "Does the source patient have a mother known to be infected with Hepatitis B?"
                }}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientHivInfectedSexualPartners")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientHivInfectedSexualPartners",
                    questionText: "Has the source patient had known HIV infected sexual partners?"
                }}
            />}
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientReceivedUnscreenedBlood")) &&
            <YesNoUnknownDropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientReceivedUnscreenedBlood",
                    // eslint-disable-next-line max-len
                    questionText: "Has the source patient received unscreened blood or untreated plasma products (in the UK prior to September 1991 and 1985 respectively)?"
                }}
            />}
            <DropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientHivStatus",
                    questionText: "HIV Status"
                }}
                options={[
                    { value: "Negative", text: "Negative" },
                    { value: "Positive", text: "Positive" },
                    { value: "Unknown", text: "Unknown" }
                ]}
            />
            {getAnswerToQuestionWithId(props.questions, "SourcePatientHivStatus") === "Positive" &&
                <YesNoUnknownDropdownQuestion
                    mandatory
                    readonly={props.readonly}
                    questionConfig={{
                        id: "SourcePatientOnRetroviralTherapy",
                        questionText: "Are they on retroviral therapy?"
                    }}
                />}
            <DropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientHbsagStatus",
                    questionText: "HbSAg Status"
                }}
                options={[
                    { value: "Negative", text: "Negative" },
                    { value: "Positive", text: "Positive" },
                    { value: "Unknown", text: "Unknown" }
                ]}
            />
            <DropdownQuestion
                mandatory
                readonly={props.readonly}
                questionConfig={{
                    id: "SourcePatientHcvStatus",
                    questionText: "HCV Status"
                }}
                options={[
                    { value: "Negative", text: "Negative" },
                    { value: "Positive", text: "Positive" },
                    { value: "Unknown", text: "Unknown" }
                ]}
            />
            {(getAnswerToQuestionWithId(props.questions, "SourcePatientBloodRecommended"))
            && <MultiButtonQuestion
                questionConfig={{
                    id: "SourcePatientBloodRecommended",
                    questionText: "Are the source patient blood recommended?"
                }}
                readonly={props.readonly}
                mandatory
            />}
            <Message info>
                HIV Risk in Source:
                <List bulleted>
                    <List.Item>Low Risk = No risk factors for HIV identified</List.Item>
                    <List.Item>High Risk = One or more HIV risk factors identified</List.Item>
                    <List.Item>Known HIV = Must Refer</List.Item>
                </List>
            </Message>
        </AccordionQuestionnaireSection>
    );
};
